/* global twttr */
import React from 'react';
import PropTypes from 'prop-types';
import { attachScript } from '../../../../../common/utils/attach-script';
import { AccessibleSocialButton } from './accessible-social-button';
const LIBRARY_URL = 'https://platform.twitter.com/widgets.js';
const buttonOptions = {
    showScreenName: false,
    showCount: false,
    size: 'small',
};
export class TwitterButton extends React.Component {
    constructor() {
        super(...arguments);
        this.init = (containerNode) => twttr.widgets.createFollowButton(this.props.cardData.id, containerNode, buttonOptions);
    }
    attachScript() {
        if (window.twttr) {
            return Promise.resolve();
        }
        return attachScript(LIBRARY_URL);
    }
    render() {
        const { isAccessible, twitterButtonTitle } = this.props;
        return (React.createElement(AccessibleSocialButton, { isAccessible: isAccessible, title: twitterButtonTitle, attachScript: this.attachScript, initButton: this.init }));
    }
}
TwitterButton.propTypes = {
    cardData: PropTypes.object,
    isAccessible: PropTypes.bool,
    twitterButtonTitle: PropTypes.string,
};
//# sourceMappingURL=twitter.js.map